import { useFormContext } from "react-hook-form";
import { Switch } from "@/components/ui/switch";
import { FieldInput } from "@/components/businesses/fields/FieldInput";
import { PendingDocumentsList } from "./PendingDocumentsList";
import type { WizardValues } from "./schema";

export const ComplianceStep = () => {
  const { watch, setValue } = useFormContext<WizardValues>();
  const medical = !!watch("isMedicalProfessional");

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-3">
        <FieldInput<WizardValues>
          name="gstNumber"
          label="GST"
          placeholder="15 chars"
          autoUpper
        />
        <FieldInput<WizardValues>
          name="panNumber"
          label="PAN"
          placeholder="ABCDE1234F"
          autoUpper
        />
        <FieldInput<WizardValues>
          name="tradeLicenseNumber"
          label="Trade licence"
        />
        <FieldInput<WizardValues>
          name="fssaiNumber"
          label="FSSAI"
          placeholder="14 digits"
        />
        <FieldInput<WizardValues>
          name="shopEstablishmentNumber"
          label="Shop establishment"
        />
      </div>

      <label className="flex items-center gap-2 text-sm">
        <Switch
          checked={medical}
          onCheckedChange={(v) =>
            setValue("isMedicalProfessional", v, { shouldValidate: true })
          }
        />
        Medical professional business
      </label>

      {medical ? (
        <div className="grid md:grid-cols-2 gap-3 border-l-2 border-primary pl-4">
          <FieldInput<WizardValues>
            name="medicalRegistrationNo"
            label="Registration no."
          />
          <FieldInput<WizardValues> name="medicalCouncil" label="Council" />
          <div className="md:col-span-2">
            <FieldInput<WizardValues>
              name="medicalQualifications"
              label="Qualifications"
              textarea
              rows={3}
            />
          </div>
        </div>
      ) : null}

      <div className="border-t border-border pt-4">
        <PendingDocumentsList />
      </div>
    </div>
  );
};
